import { ColumnsType } from 'antd/lib/table';
import { MSPlanCarrier } from '../../types/data/ms-plan-carrier.type';
import { columnSearchFilter } from '../table-utils/columnSearchFilter';

export const getMNSPlanCarrierColumns = (): ColumnsType<MSPlanCarrier> => [
  {
    title: 'Name of the Carrier',
    dataIndex: 'name',
    key: 'name',
    align: 'center',
    width: '100%',
    ...columnSearchFilter<MSPlanCarrier>('name'),
    sorter: (a, b) => a.name.localeCompare(b.name)
  }
];
